import { TooltipMapIcon } from 'components/UI/TooltipMapIcon';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { getText } from 'services/languageService';
import { setOpenSubstrModalAction } from 'store/actions/mainPage';
import { LayersModal } from 'components/MapElements/LayersElement/LayersModal';
import { MapElementIcon } from 'components/UI/MapElementIcon';
import { Box, IconButton } from '@mui/material';
import LayersIcon from '@mui/icons-material/Layers';

export const LayersElement: React.FC = () => {
  const { openSubstrateModal } = useAppSelector((state) => state.mainPage);
  const dispatch = useAppDispatch();

  const handleOpen = () => {
    dispatch(setOpenSubstrModalAction(true));
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <TooltipMapIcon title={getText('SUBSTRATE_TL')}>
        <MapElementIcon id="layers-btn" sx={{ ml: '1px' }}>
          <IconButton onClick={handleOpen} disabled={openSubstrateModal}>
            <LayersIcon />
          </IconButton>
        </MapElementIcon>
      </TooltipMapIcon>
      <LayersModal />
    </Box>
  );
};
